import { z } from 'zod';
export const onboardingFinancesFormSchema = z.object({
  ficoScore: z
    .number()
    .min(300, 'Scores range from 300-850.')
    .max(850, 'Scores range from 300-850.'),
  annualIncome: z.number().min(0),
  monthlyLiabilities: z.number().min(0),
});

export type OnboardingFinancesFormShape = z.infer<
  typeof onboardingFinancesFormSchema
>;
